// Resultados (7.3i): pedidos, gastos y el histórico de los archivos anteriores para el estado de resultados.
import type { SupabaseClient } from '@supabase/supabase-js';
import { cargarGastos, type Gasto } from './gastos';
import { cargarPedidos, todas } from './pedidos';
import type { FilaHistorica } from '../logica/resultados';
import type { Pedido } from '../logica/pedidos';

export interface MetaHistorico { fuente: string; criterio: string; notas: Record<string, string>; utilidad_preoperativa_segun_archivo: Record<string, number> }
export interface DatosResultados { pedidos: Pedido[]; gastos: Gasto[]; logistica: Set<number>; historico: FilaHistorica[]; meta: MetaHistorico | null }

export async function cargarDatosResultados(sb: SupabaseClient): Promise<DatosResultados> {
  const [{ pedidos }, gastos, cat, hist, par] = await Promise.all([
    cargarPedidos(sb), cargarGastos(sb),
    sb.from('categorias').select('id').eq('ambito', 'gasto').eq('logistica', true),
    todas<FilaHistorica>((a, b) => sb.from('resultados_historicos').select('anio, mes, concepto, valor').not('mes', 'is', null).order('anio').order('mes').range(a, b)),
    sb.from('parametros').select('valor').eq('clave', 'resultados_historicos').maybeSingle(),
  ]);
  const error = cat.error || par.error;
  if (error) throw new Error(error.message);
  return { pedidos, gastos, logistica: new Set((cat.data || []).map(c => c.id as number)), historico: hist.map(h => ({ ...h, valor: +h.valor })), meta: (par.data?.valor as MetaHistorico) || null };
}
